<template>
  <div>
    <base-card :loading="loading" class="rounded-lg">
      <party-header-navigation-bar :party="party" type="management" />
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="tab in loading ? [] : tabsFiltered"
          class="rounded-lg"
          :key="tab.component"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="rounded-b-xl"
        :touchless="tabsFiltered[tab]?.touchless"
      >
        <v-tab-item
          v-for="item in loading ? [] : tabsFiltered"
          :key="item.name"
        >
          <component
            :is="item.component"
            :party="party"
            @refresh="getParty"
            class="px-4 pb-4"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <refund-ticket :party="party" />
    <tecnician-daily :party="party" />

    <!-- Navgation  -->
    <PartyBottomSheetNavigation group="management" :party="party" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PartyTicketsManagement from "@/components/admin/party/PartyTicketsManagement";
import OfflinePaymentsManagement from "@/components/admin/party/OfflinePaymentsManagement.vue";
import SaleLinkManagement from "@/components/admin/party/SaleLinkManagement.vue";
import TicketRefunds from "@/components/admin/party/TicketRefunds.vue";
import CouponManagement from "@/components/admin/party/CouponManagement.vue";
import CourtesyEmitter from "@/components/admin/party/CourtesyEmitter.vue";
import RefundTicket from "@/components/admin/modals/RefundTicket.vue";
import PartySeller from "@/components/admin/party/PartySeller";
import PartyTicketOffice from "@/components/admin/party/PartyTicketOffice";
import PartyQueue from "@/components/admin/party/PartyQueue.vue";
import TecnicianDaily from "@/components/global/tecnician/TecnicianDaily.vue";
import PartyHeaderNavigationBar from "./modules/PartyHeaderNavigationBar.vue";

import PartyBottomSheetNavigation from "@/components/admin/party/PartyBottomSheetNavigation.vue";

import partyTabs from "@/definitions/partyTabs";

export default {
  metaInfo() {
    return { title: `⚙️ ${this.party?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    party: null,
    tab: null,
    tabs: partyTabs.management,
  }),
  methods: {
    ...mapActions("organization", ["partyById"]),
    async getParty() {
      try {
        this.loading = true;
        var response = await this.partyById(this.$route.params.partyId);
        this.party = response;
        this.loading = false;
        this.tab = 0;
        this.selectTab();
        this.$root.$emit("setImgBg", this.party?.cover);
      } catch (error) {
        this.$router.push({ name: "admin.parties" });
      }
    },
    selectTab() {
      if (this.$route.hash) {
        let hash = this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab.id == hash);
        if (index >= 0) this.tab = index;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter((tab) => {
        if (this.party?.isFree && tab.noFree) return false;
        if (!tab.permission) return true;
        return this.hasPermission(tab.permission);
      });
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab?.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "$route.params.partyId"() {
      this.getParty();
    },
    "selectedOrganization.id"() {
      this.$router.push({
        name: "admin.parties",
      });
    },
  },
  components: {
    TecnicianDaily,
    PartyTicketsManagement,
    OfflinePaymentsManagement,
    SaleLinkManagement,
    CourtesyEmitter,
    TicketRefunds,
    RefundTicket,
    PartySeller,
    PartyQueue,
    PartyTicketOffice,
    CouponManagement,
    PartyHeaderNavigationBar,
    PartyBottomSheetNavigation,
  },
  destroyed() {
    this.$root.$emit("setImgBg", null);
  },
  mounted() {
    this.getParty();
  },
};
</script>

<style></style>
